<app-tile-border>
	<div class="d-flex h-100 flex-row position-relative">
		<div [ngClass]="backgroundClass" class="d-flex flex-column border-end focus-size">
			<div [ngClass]="defaultTextClass" class="fw-bold flex-grow-1 px-2 pt-2">{{ tile?.supertitleKey | translate }}</div>
			<div class="d-flex flex-column h-100 align-items-center justify-content-center">
				@if (tile?.title.cssMaskClass) {
					<div [ngClass]="[tile?.title.cssMaskClass, maskClass]" class="mask-settings mask-size"></div>
				}
				@if (tile?.title.contentKey) {
					<div
						class="fw-bold h1 m-0"
						[ngClass]="titleClass"
						[innerHTML]="tile?.title.contentKey | numberFormat | translate"></div>
				}
				<div [ngClass]="defaultTextClass" class="text-center">{{ tile?.subtitleKey | translate }}</div>
			</div>
			<div class="fw-bold flex-grow-1 px-1 pt-1">
				<div style="visibility: hidden" [ngClass]="defaultTextClass" class="fw-bold flex-grow-1 px-1 ps-1">
					{{ tile?.supertitleKey | translate }}
				</div>
			</div>
		</div>
		<div class="d-flex align-items-center w-100 justify-content-center position-relative">
			<ng-content></ng-content>
			@if (showWatermark) {
				<app-watermark [type]="watermarkType" [size]="watermarkSize" class="position-absolute"></app-watermark>
			}
		</div>
	</div>
</app-tile-border>
